import PageLayout from "@/components/feature/PageLayout";
import useSeo from "@/hooks/useSeo";
import Hero from "./components/Hero";
import RankFeature from "./components/RankFeature";
import BooklistSection from "./components/BooklistSection";
import DiscussionSection from "./components/DiscussionSection";
import FaqSection from "./components/FaqSection";
import { faqs } from "./components/faqData";

const siteJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "笨狗漫画网",
    url: "https://comicsur.github.io/",
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://comicsur.github.io/rank?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  },
];

export default function Home() {
  useSeo({
    title: "笨狗漫画网 - 漫画排行榜与推荐，热门作品不错过",
    description:
      "在笨狗漫画网，你可以参考漫画排行榜和编辑推荐，还能浏览评论区、精选书单、社区讨论与评分，帮你快速决定追哪部热门作品。",
    jsonLd: siteJsonLd,
  });

  return (
    <PageLayout>
      <Hero />
      <RankFeature />

      <section className="bg-background-100 py-14 md:py-16">
        <div className="mx-auto max-w-7xl px-4 md:px-6 text-center">
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">
            热门分类，一键直达
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
            从热血到治愈，从悬疑到恋爱，总能找到你喜欢的漫画类型
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            {["热血", "治愈", "科幻", "玄幻", "悬疑", "恋爱", "武侠", "搞笑", "奇幻"].map((g, i) => (
              <a
                key={g}
                href="#categories"
                className={`rounded-full px-5 py-2.5 text-sm font-medium transition-transform hover:-translate-y-0.5 ${
                  i % 3 === 0
                    ? "bg-primary-500 text-background-50"
                    : i % 3 === 1
                    ? "bg-accent-500 text-background-50"
                    : "bg-secondary-500 text-background-50"
                }`}
              >
                {g}
              </a>
            ))}
          </div>
        </div>
      </section>

      <BooklistSection />
      <DiscussionSection />
      <FaqSection />
    </PageLayout>
  );
}